import React from 'react';

import { SearchFormFieldEnum } from '../../common/searchFormField.types';
import { CriteriaOperatorEnum, CriteriaTypeEnum, SearchQueryRequestType } from '../../common/types';
import { ProjectType } from '../../features/projects/ProjectsTable.types';
import { useSearchProjects } from '../../features/projects/useSearchProjects';

import { FormSelectWithSearch } from './FormSelectWithSearch';

export const FormProjectSelectWithSearch: React.FC<{ name?: string; required?: boolean; activeProjects?: boolean }> = ({
  name = SearchFormFieldEnum.ProjectUUID,
  required = false,
  activeProjects = false,
}) => {
  const mapFormValueToSearchPayload = (newValue?: string): SearchQueryRequestType => {
    return {
      criteria: newValue
        ? [
            {
              field: SearchFormFieldEnum.Name,
              value: newValue,
              operator: CriteriaOperatorEnum.LK,
              type: CriteriaTypeEnum.MUST,
            },
          ]
        : [],
      sort: [],
      from: 0,
      max: 10000,
    };
  };

  const mapResponseToOptions = (results: ProjectType[]) => {
    const projects = activeProjects ? results.filter((project) => project.active) : results;

    return projects.map((project) => ({
      value: project.uuid,
      label: `${project.name} (${project.client.name})`,
    }));
  };

  return (
    <FormSelectWithSearch
      name={name}
      label="Project"
      search={useSearchProjects}
      mapFormValueToPayload={mapFormValueToSearchPayload}
      mapResponseToOptions={mapResponseToOptions}
      required={required}
    />
  );
};
